import React from 'react';
import { IReadingList, IReadingListItem } from '../../../../subscriptions/models/ReadingList';
import { ManningOnlineStore } from '../../../../subscriptions/store/ManningOnlineStore';

import { IProductDescription } from '../../../models/product/IProductDescription';
import { TaggedProductListWithDetails } from '../../../../subscriptions/components/taggedProductListWithDetails/TaggedProductListWithDetails';

export interface IProps {
    store: ManningOnlineStore;
    readingList: IReadingList;
    
    pretitle?: string;
    subtitle?: string;

    disableSelection?: boolean;
    canAddProduct?: boolean;
    canReorder?: boolean;

    onRef?: (ref) => void;
    onCloseClick?: () => void;

    isReordering?: boolean;

    onReorder?: (readingList: IReadingList) => void;
    onMoveUp?: (readingList: IReadingList) => void;
    onMoveDown?: (readingList: IReadingList) => void;
}

export interface IState {
    selectedItem: IReadingListItem;
    relatedProduct: IProductDescription;
}

export class ReadingList extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    private listContainer: HTMLElement;
    
    constructor(props: IProps){
        super(props);

        this.onReadingListTitleClick = this.onReadingListTitleClick.bind(this);
        this.onRemoveProductFromReadingList = this.onRemoveProductFromReadingList.bind(this);
        this.onRemoveReadingList = this.onRemoveReadingList.bind(this);
        this.onDeleteReadingList = this.onDeleteReadingList.bind(this);
        this.onReorder = this.onReorder.bind(this);

        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDragDrop = this.onDragDrop.bind(this);

        this.onRootRef = this.onRootRef.bind(this);

        this.onMoveUp = this.onMoveUp.bind(this);
        this.onMoveDown = this.onMoveDown.bind(this);
        
        this.state = {
            selectedItem: null,
            relatedProduct: null
        };
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
    }

    public render(){
        return <TaggedProductListWithDetails store={this.props.store}
                                             onTitleClick={this.onReadingListTitleClick}
                                             onRemoveProductClick={this.onRemoveProductFromReadingList}
                                             pretitle={this.props.pretitle}
                                             subtitle={this.props.subtitle}
                                             taggedProductList={this.props.readingList}
                                             id={this.props.readingList.id}
                                             advancedOperation={{
                                                id: this.props.readingList.id,
                                                share: this.props.store.shareReadingList,
                                                emailTitle: "View my Manning list",
                                                onChangeTitle: this.onReadingListTitleClick,
                                                onDelete: this.onDeleteReadingList,
                                                onReorder: this.props.canReorder ? this.onReorder : null
                                             }}
                                             disableSelection={this.props.disableSelection}
                                             onDragEnter={this.onDragEnter}
                                             onDragLeave={this.onDragLeave}
                                             onDragOver={this.onDragOver}
                                             onDragDrop={this.onDragDrop}
                                             onRootRef={this.onRootRef}

                                             onMoveUp={this.props.canReorder ? this.onMoveUp : null}
                                             onMoveDown={this.props.canReorder ? this.onMoveDown : null}
                                             isReordering={this.props.isReordering} 

                                             onCloseClick={this.props.onCloseClick}>
                    {this.props.canAddProduct && <div className='product-placeholder'>
                        <button onClick={() => this.props.store.selectLibraryTab()}>
                            <i className='fa fa-plus'/>
                        </button>
                    </div> }
            </TaggedProductListWithDetails>
    }

    private onRootRef(root: HTMLElement){
        if(root != null){
            this.listContainer = root.querySelector(".tagged-product-list-products-container");
        }
        else {
            this.listContainer = null;
        }

        this.props.onRef && this.props.onRef(root);
    }

    private onDeleteReadingList(){
        const readingList = this.props.readingList;
        let title = readingList.title;
        if(!title && readingList.products.length > 0){
            title = readingList.products[0].title;            
        }

        let message = title ? `Delete list ${title}?` : "Delete empty list?";

        if(confirm(message)){
            this.props.store.deleteReadingList(readingList);
        }
    }
    
    private onReadingListTitleClick(){
        const readingList = this.props.readingList;
        const newTitle = prompt(`Change ${readingList.title} to`, readingList.title);
        if(newTitle && readingList.title != newTitle) {
            this.props.store.changeReadingListTitle(readingList, newTitle);
        }
    }

    private isRemoveDisabled: boolean;
    private onRemoveProductFromReadingList(readingListItem: IReadingListItem){
        if(this.isRemoveDisabled) { return; }
        
        this.isRemoveDisabled = true;
        this.props.store.removeProductFromReadingList(this.props.readingList, readingListItem).finally(() => {
            this.isRemoveDisabled = false;

            if(this.hasBeenMounted && this.state.selectedItem == readingListItem){
                 this.setState({
                    selectedItem: null
                });
            }
        });
    }

    private onRemoveReadingList(readingList: IReadingList){
        this.props.store.deleteReadingList(readingList);
    }

    private onDragEnter(e){
        e.preventDefault();
        this.disableSmoothScroll();
    }

    private onDragOver(e){
        e.preventDefault();

        this.updateProductCardStylesAndReturnTargetBoundryIndexes(e);
        this.updateScrollPositionBasedOnDrag(e);   
    }
    
    private updateScrollPositionBasedOnDrag(e: any) {
        const parentBoundingRectangle = this.listContainer.parentElement.getBoundingClientRect();
        const wrapperX = e.pageX - (window.pageXOffset + parentBoundingRectangle.left);
        const wrapperWidth = parentBoundingRectangle.width;
        
        if(wrapperX <= 110){
            this.listContainer.scrollBy({left: -2, behavior: "auto"});
        }
        else if(wrapperX + 110 >= wrapperWidth){
            this.listContainer.scrollBy({left: 2, behavior: "auto"});
        }
    }

    private onDragLeave(e){
        const boundingClient = this.listContainer.getBoundingClientRect();
        const y = e.pageY - (window.pageYOffset + boundingClient.top);

        if(y <= 0 || y >= boundingClient.height) { this.removeShuffle(); }
    }

    private onDragDrop(e){
        e.preventDefault();
        let dataString = ""
        try {
            if(e.dataTransfer){
                dataString = e.dataTransfer.getData("text");
                const data = JSON.parse(dataString);
                const productId = data.productId;

                const newIndex = this.updateProductCardStylesAndReturnTargetBoundryIndexes(e);
                let promise = null;
                if(newIndex >= 0){
                    promise = this.props.store.moveReadingListItemToNewIndex(this.props.readingList, productId, newIndex);
                    this.disableSmoothScroll();
                    promise.finally(() => {
                        setTimeout(() => {
                            this.enableSmoothScroll();
                        }, 16);
                    });
                }
            }
        }
        catch(e){
            console.log(e, dataString);
        }

        this.removeShuffle();

        return false;
    }

    private removeShuffle(){
        if(this.listContainer == null) { return; }
        
        const productCards = this.listContainer.querySelectorAll(".product-card-root");
        for(let i = 0; i < productCards.length; i++){
            productCards[i].classList.remove("shuffle-left");
            productCards[i].classList.remove("shuffle-right");
        }
    }

    private updateProductCardStylesAndReturnTargetBoundryIndexes(e){
        let targetIndex = -1;
        if(!this.listContainer) { return targetIndex; }

        const boundingRectangle = this.listContainer.getBoundingClientRect();
        
        const x = e.pageX - (window.pageXOffset + boundingRectangle.left - this.listContainer.scrollLeft);

        let draggedProductCard: HTMLElement = e.target.parentElement;
        if((window as any).currentlyDraggedCover != null){
            draggedProductCard = (window as any).currentlyDraggedCover.parentElement
        }
        else {
            draggedProductCard =  e.target.parentElement as HTMLElement;
        }

        if(!this.isInCurrentList(draggedProductCard)) { return targetIndex; }
        
        const draggedProductCardWidth = draggedProductCard.classList.contains("wide-product-card") ? 232 : 105;
        const shuffleOffset = `${Math.floor(draggedProductCardWidth/2)}px`;

        const productCards = this.listContainer.querySelectorAll(".product-card-root");

        let itemPositions: { x: number, width: number, productCard: HTMLElement }[] = [];
        let currentXPosition = 10;
        let indexToShuffleLeft: number = -1;
        let indexToShuffleRight: number = -1;
        let hasFoundBorderItems: boolean = false;
        let currentDraggedCardIndex: number = -1;
        for(let i = 0; i < productCards.length; i++){
            const productCard = productCards[i] as HTMLElement;
            const increment = productCard.classList.contains("wide-product-card") ? 257 : 130;

            itemPositions.push({x: currentXPosition, width: increment, productCard: productCard});
            if(currentXPosition + increment/2 > x && !hasFoundBorderItems){
                indexToShuffleLeft = i - 1;
                indexToShuffleRight = i;
                hasFoundBorderItems = true;
            }
            
            if(!hasFoundBorderItems && i == productCards.length - 1){
                indexToShuffleLeft = i;
                indexToShuffleRight = -1;
                hasFoundBorderItems = true;
            }

            currentXPosition += increment;

            if(productCard == draggedProductCard){
                currentDraggedCardIndex = i;
            }
        }

        if(productCards[indexToShuffleLeft] == draggedProductCard
        || productCards[indexToShuffleRight] == draggedProductCard){
            indexToShuffleLeft = -1;
            indexToShuffleRight = -1;
        }

        if(indexToShuffleLeft >= 0){
            const productCard = itemPositions[indexToShuffleLeft].productCard;
            productCard.classList.add("shuffle-left");
            productCard.style.setProperty("--shuffle-offset", shuffleOffset);
        }
        
        if(indexToShuffleRight >= 0){
            const productCard = itemPositions[indexToShuffleRight].productCard;
            productCard.classList.add("shuffle-right");
            productCard.style.setProperty("--shuffle-offset", shuffleOffset);
        }

        for(let i = 0; i < productCards.length; i++){
            const productCard = productCards[i];
            
            if(i != indexToShuffleLeft){ productCard.classList.remove("shuffle-left"); }
            if(i != indexToShuffleRight){ productCard.classList.remove("shuffle-right"); }
        }

        let index = currentDraggedCardIndex > indexToShuffleRight ? indexToShuffleRight : indexToShuffleLeft;
        
        if(index == -1 && indexToShuffleLeft >= 0) { return indexToShuffleLeft; }
        if(index == -1 && indexToShuffleRight >= 0) { return indexToShuffleRight; }

        return index;
    }

    private isInCurrentList(productCard: HTMLElement): boolean {
        if(this.listContainer == null) { return false; }

        return this.listContainer.contains(productCard);
    }

    private disableSmoothScroll(){
        this.listContainer && this.listContainer.classList.add("disable-smooth-scroll");
    }

    private enableSmoothScroll(){
        this.listContainer && this.listContainer.classList.remove("disable-smooth-scroll");
    }

    private onReorder(){
        this.props.onReorder && this.props.onReorder(this.props.readingList);
    }

    private onMoveUp(){
        this.props.onMoveUp && this.props.onMoveUp(this.props.readingList);
    }

    private onMoveDown(){
        this.props.onMoveDown && this.props.onMoveDown(this.props.readingList);
    }
}
